/*
 * $Id:: constants.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

export const GLOBALS_SLICE_NAME = 'globals';
export const LITERALS_SLICE_NAME = 'literals';
export const NOTIFICATIONS_SLICE_NAME = 'notifications';
